import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rewards-confirmation',
  templateUrl: './rewards-confirmation.component.html',
  styleUrls: ['./rewards-confirmation.component.scss']
})
export class RewardsConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
